// extracted by mini-css-extract-plugin
export default {"contenedor":"CampoBuscarClub_contenedor__S6nNu","boton":"CampoBuscarClub_boton__UTxjT"};